export const QUERY_KEYS = {
  AUTH_CURRENT_GET: "AUTH_CURRENT_GET",
  NOTE_LIST_GET: "NOTE_LIST_GET",
  NOTE_GET: "NOTE_GET",
};
